import multiRequest from '../shared/multiRequest';

const getProfile = () =>
  multiRequest([
    {
      url: `marketplace/subscription-sms/v1/profile`,
      method: 'GET',
    },
  ]);

const unsubscribe = ({ productId, shortCode }) =>
  multiRequest([
    {
      url: 'marketplace/subscription-sms/v1/unsuscribe',
      method: 'POST',
      data: {
        productId,
        shortCode,
      },
    },
  ]);

const SmsPremiumService = {
  getProfile,
  unsubscribe,
};

export default SmsPremiumService;
